import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import { WidgetPropsUnion } from '@/models/widgets/widget-props-union';
import { plainToClass } from 'class-transformer';
import { WidgetsPropsMap } from '@/models/widgets/widgets-props-map';

export default class ComponentPropsManager {
  private props: WidgetPropsUnion[];

  constructor(field: SurveyElementsUnion) {
    this.props = this.setProps(field.elementType!, field);
  }

  private setProps(
    key: COMPONENT_TYPES,
    element: SurveyElementsUnion
  ): WidgetPropsUnion[] {
    return plainToClass(
      WidgetsPropsMap[key as keyof WidgetPropsUnion],
      element,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  public getProps(): WidgetPropsUnion[] {
    return this.props;
  }
}
